import type { LanguageStorage } from "@noa/i18n";

const I18NEXT_STORAGE_KEY = "i18nextLng";

export const localLanguageStorage: LanguageStorage = {
  store: (code) => localStorage.setItem(I18NEXT_STORAGE_KEY, code),
  load: () => localStorage.getItem(I18NEXT_STORAGE_KEY),
};
